module.exports = __webpack_public_path__ + "static/media/showcase-look-view.4b07f30b.png";